import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Row, Col, Form, AutoComplete, Input, Select, Checkbox, Upload, message, Spin, Drawer, Space, Modal, Table, Typography } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import "moment-timezone";
import ImgCrop from 'antd-img-crop';
import { Scrollbars } from 'react-custom-scrollbars';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Link, useHistory } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import { useDispatch, useSelector } from 'react-redux';
import InitialData from './InitialData.json'
import DetailsPage from './DetailsPage/Detailspage';
import LeadFields from './DetailsPage/LeadDetailsFields'
import RelatedTab from './DetailsPage/RelatedTab'
import LeadRightData from './DetailsPage/LeadRightData'
import LeadStatusBar from './DetailsPage/LeadStatusBar'
import AddTaskPage from './AddTask'
import { UploadUserTag } from './GlobalComponents/UserCardCmnts'
import { RelatedDocUpload } from './GlobalComponents/RelatedDocUpload'
import TinyMCEEditor from "../EditorFolder/RichEmailEditor"
import { setEditCall, setReDirCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { useChatCurrentView } from '../../../redux/CrmReduxCalls/ChatCurrentView';
import { AddUser } from '../style';
import { hunterioLeadDetails } from '../../../Api/Services/CompanyApiService'
import { getStateData, getCityData, getAllUsersData, getRating, getAnnualRevenue, IndustryData, getNoofEmployee, getLeadsourceData, getSeniorityLevelData, getLeadStatusData, getCountryData, getTitle } from '../../../Api/Services/CommonApiService'
import { LeadDetailData, LeadSave, AllLeadPagination, AllLeadPaginationByDep, LeadUpdate, fetchAllLeadsByAccountName, fetchAllLeadsByCompanyAndAccount } from '../../../Api/Services/LeadApiServices';
import { AllAccountPaginationSearch, generateAccountDescription } from '../../../Api/Services/AccountApiService';
import { useNavigationDecrypted, useExcryptedNavigation } from '../Filters/FilterConditions';
import { Main, BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import { getAxiosInstance } from '../../../Api/ApiConfig'
import ConvertPopup from "../Popup/LEMassPopup"
import NotesPopup from '../Popup/NotesPopup'
import CallLogPopup from '../Popup/CallLogPopup'
import AllCancelPopup from '../Popup/AllCancelPopup';
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import Approvaldialog from '../Popup/Approvaldialog'
import ComposeMail from '../Email/Compose';
import MeetingLiPopup from '../Popup/MeetingLiPopup'
import MergePage from '../Popup/MergePage'
import SharePopup from '../Popup/SharePopup'
import AddtoSegment from '../Popup/AddtoSegment'
import AddtoOutreachPopup from '../Popup/AddtoOutreachPopup'
import { CalendarIcon, AiIcon, CloneIcon, EditIcon, ShareIcon, CancelIcon, QUSOINIcon, DeleteIcon, SaveIcon, ChangeOwnerIcon, MergeIcon, ConvertIcon, EmailIcon, TaskIcon, NotesIcon, CallLogIcon, SegmentIcon, EmailseqQueueIcon } from '../../../components/Icons/Icons';
import { useProFeatureGuard, PRO_FEATURE_NAMES, mobileOnChangeValidator, nameOnChangeValidator, validateLinkedInUrl, validateZipCode, validateTextField, validateUrlField, validateEmailField, validateAddressLine } from '../../../components/utilities/utilities';

const { Option } = Select;

function AddNew({ UrlId, FromPage, setCratePage, GetAll, ShortCut, fromEmail, CallBack, MailData }) {
    const scrollRef = useRef(null);
    const getFieldPopupContainer = (triggerNode) =>
        scrollRef.current?.view ||
        triggerNode.closest('.ant-drawer-content') ||
        triggerNode.closest('.ant-modal-content') ||
        document.body;
    const loadingRef = useRef(false);
    const prevValues = useRef({ UrlId: "", FromPage: "" });
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const { emailapiValues, emailactiontype } = useSelector((state) => state.EmailData);
    const dispatch = useDispatch();
    const { allowed: proAllowed, block: blockPro } = useProFeatureGuard();
    const history = useHistory();
    const [form] = Form.useForm();
    const reDirRedux = useSelector((state) => state.reDirRedux.url);
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const [editField, setEditField] = useState(false)
    const [doubleClick, setDoubleClick] = useState(false)
    const [deleteClick, setDelteClick] = useState(false)
    const permission = localData.permissions
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const isRestricted =
        profile.department === "Customer Care" || profile.department === "Marketing";
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const currentDate = new Date(currentrealTime);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const formattedTime = `${hours}:${minutes}`;
    const [trigger, setTrigger] = useState()
    const [leadInitial, setLeadInitial] = useState()
    const [relatedLead, setRelatedLead] = useState()
    const [content1, setContent1] = React.useState();
    const [content2, setContent2] = React.useState();
    const [aiLoading, setAiLoading] = useState(false);
    const [edit, setEdit] = useState(false)
    const [approveOpen, setApproveOpen] = useState(false)
    const [leadId, setLeadId] = useState()
    useChatCurrentView('lead', leadId)
    const [displayData, setDisplayData] = useState()
    const [country, setCountry] = useState()
    const [allCountry, setAllCountry] = useState([])
    const [state, setState] = useState()
    const [allState, setAllState] = useState([])
    const [city, setCity] = useState()
    const [allCity, setAllCity] = useState([])
    const [checked, setChecked] = useState(false)
    const [image, setImage] = useState()
    const [uiReady, setUiReady] = useState(false)
    const [leadStatus, setLeadStatus] = useState([])
    const [leadStatusData, setLeadStatusData] = useState([])
    const [seniority, setSeniority] = useState([])
    const [imageUploading, setImageUploading] = useState(false)
    const [leadsource, setLeadSource] = useState([])
    const [users, setUsers] = useState([])
    const [industryData, setIndustryData] = useState([])
    const [FILEList, setFileList] = useState([]);
    const [popup, setPopup] = useState(false)
    const [values, setValues] = useState()
    const [deleteOption, setDeleteOpen] = useState(false);
    const [campaignPopup, setCampaignPopup] = useState(false)
    const [outreachPopup, setOutreachPopup] = useState(false)
    const [popupType, setPopupType] = useState()
    const [action, setAction] = useState()
    const [assignOwner, setAssignOwner] = useState()
    const [notePopup, setNotePopup] = useState(false)
    const [callLogPopup, setCallLogPopup] = useState(false)
    const [NacTrigger, setNaCTrigger] = useState()
    const [page, setPage] = useState()
    const [mailOpen, setMailOpen] = useState(false)
    const [taskProp, setTaskProp] = useState()
    const [taskPage] = useState("AddPage")
    const [dataDisables, setDataDisables] = useState({
        isDisable: false,
        allow: false,
        id: null,
        profile: null
    })
    const [drawerPage, setDrawerPage] = useState()
    const [pages] = useState("Meeting")
    const [dataPermissions, setDataPermissions] = useState()
    const [createPageTask, setCreatePageTask] = useState()
    const [popupMessage, setPopupMessage] = useState(false)
    const [meetingOpen, setMeetingOpen] = useState(false)
    const [account, setAccount] = useState([])
    const [rating, SetRating] = useState([])
    const [title, setTitle] = useState([])
    const [noofemployee, setNoofemployee] = useState([])
    const [revenue, setRevenue] = useState([])
    const [sharePopup, setSharePopup] = useState(false)
    const [mergeOpen, setMergeOpen] = useState(false)
    const [approveCondition, setApproveCondition] = useState(false)
    const [meetingAttendees, setMeetingAttendees] = useState([])
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [permissions] = useState(permission.entity)
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const PageCancel = () => {
        if (reDirRedux) {
            history.push(reDirRedux)
        }
        else {
            history.push('/Home/leads')
        }
        dispatch(setReDirCall(null));
    }
    // Create
    const canCreate = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        return hasRolePermission;
    };
    // Share
    // const canShare = (dataPermissions, action) => {
    //     if (!dataPermissions) return false;
    //     const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
    //     const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
    //     return hasDataPermission;
    // };
    // Update/Delete
    const hasRoleDeletePermission = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        return rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
    };
    const canUpdateDelete = (rolePermissions, dataPermissions, action, actionRoleId) => {
        if (!Array.isArray(rolePermissions) || !dataPermissions) return false;
        const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
        return hasRolePermission && hasDataPermission;
    };
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => {
                modal.destroy();
                if (type === "Approve") {
                    setTimeout(() => {
                        history.push('/Home/leads')
                        // getData(leadId); // This runs after 2 seconds
                    }, 1000);
                }
            }
        });
    }
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };
    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    const getCity = async (Address, isoCode) => {
        try {
            const response = await getCityData(isoCode)
            setAllCity(response);
            if (Address.city) {
                setCity(Address.city)
            } else {
                setCity(null)
            }
        } catch (error) {
            message.error(error)
        }
    }
    const getState = async (Address, option) => {
        try {
            const response = await getStateData(option)
            setAllState(response);
            if (Address.state) {
                setState(Address.state)
                const stateinfo = response.find(states => states.state === Address.state);
                if (stateinfo) {
                    const iso = stateinfo.stateId
                    getCity(Address, iso)
                }
            } else {
                setState(null)
            }
        } catch (error) {
            message.error(error)
        }
    }
    const onnavigate = () => {
        history.push("/Home/email-config")
    }
    const ACCOUNT_SEARCH_PAGE_SIZE = 50;
    const [accountLoading, setAccountLoading] = useState(false);
    const accountSearchTimeoutRef = useRef(null);
    const accountSearchIdRef = useRef(0); // guards against stale/out-of-order responses
    async function fetchLeadAccountPagesBySearch(searchText, searchId) {
        let pageNo = 1;
        let total = 0;
        let allFetched = 0;
        /* eslint-disable no-await-in-loop */
        while (allFetched < total || pageNo === 1) {
            if (accountSearchIdRef.current !== searchId) return; // a newer search superseded this one
            let res;
            if (isRestricted) {
                res = await fetchAllLeadsByCompanyAndAccount(pageNo, ACCOUNT_SEARCH_PAGE_SIZE, searchText);
            } else {
                res = await fetchAllLeadsByAccountName(pageNo, ACCOUNT_SEARCH_PAGE_SIZE, searchText);
            }
            const items = res?.items || [];
            total = res?.total ?? 0;
            allFetched += items.length;
            if (items.length === 0) break;
            const leadAccounts = items
                .filter(item => item.account_name)
                .map(item => ({
                    value: item.account_name,
                    key: item.account_name,
                    data: {
                        status: "Not Qualified",
                        accountID: null,
                        accountProfile: null,
                        industry: item.industry,
                        rating: item.rating,
                        employee: item.nom_of_employees,
                        revenue: item.annual_revenue,
                        website: item.website,
                        description: item.account_description,
                        leadId: item.leads_id
                    }
                }));

            if (accountSearchIdRef.current !== searchId) return;
            setAccount(prev => {
                const map = new Map(prev.map(item => [item.value, item]));
                leadAccounts.forEach(item => {
                    if (!map.has(item.value)) {
                        map.set(item.value, item);
                    }
                });
                return Array.from(map.values());
            });
            if (allFetched >= total) break;
            pageNo += 1;
        }
        /* eslint-enable no-await-in-loop */
    }
    async function fetchAccountPagesBySearch(searchText, searchId) {
        let pageNo = 1;
        const keepGoing = true;
        /* eslint-disable no-await-in-loop */
        while (keepGoing) {
            if (accountSearchIdRef.current !== searchId) return;
            const res = await AllAccountPaginationSearch(pageNo, ACCOUNT_SEARCH_PAGE_SIZE, searchText);
            const items = res || [];
            if (items.length === 0) break; // empty page = stop condition
            const apiAccounts = items
                .filter(item => item.account_name)
                .map(item => ({
                    value: item.account_name,
                    key: item.account_name,
                    data: {
                        status: "Qualified",
                        accountID: item.account_id,
                        accountProfile: item.account_profile,
                        industry: item.industry,
                        rating: item.rating,
                        employee: item.nom_of_employees,
                        revenue: item.annual_revenue,
                        description: item.description,
                        website: item.website,
                        leadId: null
                    }
                }));

            if (accountSearchIdRef.current !== searchId) return;
            setAccount(prev => {
                const map = new Map(prev.map(item => [item.value, item]));
                // Qualified account data overrides lead data on name collision
                apiAccounts.forEach(item => {
                    map.set(item.value, item);
                });
                return Array.from(map.values());
            });
            pageNo += 1;
        }
        /* eslint-enable no-await-in-loop */
    }
    async function searchAllAccountOptions(searchText) {
        accountSearchIdRef.current += 1;
        const searchId = accountSearchIdRef.current;
        setAccountLoading(true);
        setAccount([]);
        try {
            await Promise.all([
                fetchLeadAccountPagesBySearch(searchText, searchId),
                fetchAccountPagesBySearch(searchText, searchId)
            ]);
        } catch (error) {
            message.error(error);
        } finally {
            if (accountSearchIdRef.current === searchId) {
                setAccountLoading(false);
            }
        }
    }
    const handleAccountSearch = (searchText) => {
        if (accountSearchTimeoutRef.current) {
            clearTimeout(accountSearchTimeoutRef.current);
        }
        const trimmed = searchText?.trim();
        if (!trimmed) {
            accountSearchIdRef.current += 1;
            setAccount([]);
            setAccountLoading(false);
            return;
        }
        accountSearchTimeoutRef.current = setTimeout(() => {
            searchAllAccountOptions(trimmed);
        }, 1000); // fire 2s after the user stops typing
    };
    useEffect(() => {
        return () => {
            if (accountSearchTimeoutRef.current) clearTimeout(accountSearchTimeoutRef.current);
        };
    }, []);
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId}
                    label={(
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                    {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                        < img src={option.profilePic} alt="profile" />
                                        :
                                        <span className="image_icon UserIcon">
                                            {option.firstName.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                </div>
                            </div>
                        </div>
                    )}
                    key={i}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function IndustryDataApi() {
        try {
            const data = await IndustryData()
            setIndustryData(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getAnnualRevenueData = async () => {
        try {
            const data = await getAnnualRevenue()
            const options = data.map((option, i) => (
                <Option value={option.annualRevenue} key={i}>
                    {option.annualRevenue}
                </Option>));
            setRevenue(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getRatingData = async () => {
        try {
            const data = await getRating()
            const options = data.map((option, i) => (
                <Option value={option.rating} key={i}>
                    {option.rating}
                </Option>));
            SetRating(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getNomEmployeeData = async () => {
        try {
            const data = await getNoofEmployee()
            const options = data.map((option, i) => (
                <Option value={option.nomOfEmployee} key={i}>
                    {option.nomOfEmployee}
                </Option>));
            setNoofemployee(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getTitleData = async () => {
        try {
            const data = await getTitle()
            const options = data.map((option, i) => (
                <Option value={option.title} key={i}>
                    {option.title}
                </Option>));
            setTitle(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getLeadsource = async () => {
        try {
            const data = await getLeadsourceData()
            const options = data.map((option, i) => (
                <Option value={option.leadSourceId} key={i}>
                    {option.leadSourceName}
                </Option>));
            setLeadSource(options)
            if (fromEmail === "fromEmail") {
                const Datas = data.find(option => option.leadSourceName === "Email Marketing")?.leadSourceId
                form.setFieldsValue({ leadSource: Datas })
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    const getLeadStatus = async () => {
        try {
            const data = await getLeadStatusData()
            const options = data.map((option, i) => (
                <Option value={option.leadStatusId} key={i}>
                    {option.leadStatusName}
                </Option>));
            setLeadStatus(options)
            setLeadStatusData(data)
            if (UrlId === undefined) {
                const Datas = data.find(option => option.leadStatusName === "Not Contacted")?.leadStatusId
                form.setFieldsValue({ leadStatus: Datas })
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    const getSeniorityLevel = async () => {
        try {
            const data = await getSeniorityLevelData()
            setSeniority(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
            if (displayData.country) {
                const countryInfo = response.find(countrys => countrys.country === displayData.country);
                if (countryInfo) {
                    const iso = countryInfo.countryId
                    getState(displayData, iso)
                }
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    async function setInitialData(value) {
        setLeadInitial({
            seniorityLevelId: normalizeValue(value.seniority_level_id),
            firstName: normalizeValue(value.first_name),
            lastName: normalizeValue(value.last_name),
            leadOwner: normalizeValue(value.lead_owner),
            designation: normalizeValue(value.designation),
            accountName: normalizeValue(value.account_name),
            industry: normalizeValue(value.industry),
            rating: normalizeValue(value.rating),
            nomOfEmployees: normalizeValue(value.nom_of_employees),
            title: normalizeValue(value.title),
            primaryEmail: normalizeValue(value.primary_email),
            secondaryEmail: normalizeValue(value.secondary_email),
            phone: normalizeValue(value.phone),
            mobile: normalizeValue(value.mobile),
            leadSourceId: normalizeValue(value.lead_source_id),
            leadStatusId: normalizeValue(value.lead_status_id),
            emailOptOut: normalizeValue(value.email_opt_out === 1 || value.email_opt_out === true),
            fax: normalizeValue(value.fax),
            description: normalizeValue(value.description),
            accountDescription: normalizeValue(value.account_description),
            leadProfile: normalizeValue(value.lead_profile),
            leadFiles: (value.lead_files || []),
            city: normalizeValue(value.city),
            street: normalizeValue(value.street),
            country: normalizeValue(value.country),
            postcode: normalizeValue(value.postcode),
            state: normalizeValue(value.state),
            annualRevenue: normalizeValue(value.annual_revenue),
            website: normalizeValue(value.website),
            linkedinUrl: normalizeValue(value.linkedin_url),
            relatedLeadId: normalizeValue(value.related_lead_id),
            tags: normalizeValue(value.tags),
        })
    }
    const setData = async (value) => {
        if (value !== undefined) {
            if (drawerPage !== "CloneLead") {
                if (value.approved_for !== "None") {
                    setApproveOpen(true)
                    setApproveCondition(true)
                }
                else {
                    setApproveOpen(false)
                    setApproveCondition(false)
                }
            }
            setAssignOwner(value.lead_owner)
            setContent1(value.description)
            setContent2(value.account_description)
            form.setFieldsValue({
                firstName: value.first_name,
                lastName: value.last_name,
                leadOwner: value.lead_owner,
                // description: value.description,
                postcode: (value.postcode === "0" || value.postcode === 0) ? null : value.postcode,
                street: value.street,
                accountName: value.account_name,
                secondaryEmail: value.secondary_email,
                leadStatus: value.lead_status_id,
                leadSource: value.lead_source_id,
                mobile: (value.mobile === "0" || value.mobile === 0) ? null : value.mobile,
                fax: value.fax,
                phone: (value.phone === "0" || value.phone === 0) ? null : value.phone,
                primaryEmail: value.primary_email,
                title: value.title,
                designation: value.designation,
                annualrevenue: value.annual_revenue,
                noofemployees: value.nom_of_employees,
                industry: value.industry,
                rating: value.rating,
                seniorityLevel: value.seniority_level_id,
                country: value.country,
                websiteName: value.website,
                linkedinUrl: value.linkedin_url,
                tags: value.tags
                    ? value.tags
                        .split(",")
                        .map((tag) => tag.trim())
                        .filter(Boolean)
                    : [],
            })
            setRelatedLead(value.related_lead_id)
            setFileList(value.lead_files || [])
            setImage(value.lead_profile)
            setDeleteOpen(value.lead_profile && value.lead_profile !== "")
            setChecked(value.email_opt_out === 1 || value.email_opt_out === true)
            setLeadId(value.leads_id)
            setStates({
                ...states,
                selectedRowKeys: [value.leads_id]
            });
            setCountry(value.country)
            handleAccountSearch(value.account_name)
        }
    }
    async function deleteMenu(id) {
        setValues([id])
        setPopup(true)
        setPopupType("Delete")
        setAction("DeleteNav")
    }
    async function ConvertApi(id) {
        setValues([id])
        setPopup(true)
        setPopupType("Convert")
        setAction("ConvertNav")
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);

        return formattedDate
    }
    async function getSharingPermissions(id) {
        if (id) {
            setDataPermissions(id)
        }
        else {
            setDataPermissions("Read,Update,Delete,Sharing")
        }
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        setApproveOpen(false)
        setApproveCondition(false)
        setAssignOwner(null)
        form.setFieldsValue({
            firstName: null,
            lastName: null,
            leadOwner: null,
            // description: null,
            postcode: null,
            street: null,
            accountName: null,
            secondaryEmail: null,
            leadStatus: null,
            leadSource: null,
            mobile: null,
            fax: null,
            phone: null,
            primaryEmail: null,
            title: null,
            designation: null,
            annualrevenue: null,
            websiteName: null,
            noofemployees: null,
            industry: null,
            rating: null,
            seniorityLevel: null,
            country: null,
            linkedinUrl: null,
            tags: null
        })
        setContent2()
        setContent1()
        setFileList([])
        setImage()
        setDeleteOpen()
        setChecked(false)
        setStates({
            ...states,
            selectedRowKeys: []
        });
        setDrawerPage()
        setCountry()
        setState()
        setCity()
        if (FromPage !== "EntityUpdate" && ShortCut !== "Shortcut" && fromEmail !== "fromEmail") {
            GetAll();
            setCratePage();
        }
        if (ShortCut === "Shortcut") {
            setCratePage()
        }
        if (fromEmail === "fromEmail") {
            setCratePage()
        }
        if (drawerPage === "CloneLead" || ShortCut === "Shortcut" && fromEmail !== "fromEmail") {
            PageCancel()
        }
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
        setUiReady(false)
    }
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false)
        setDrawerPage()
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    async function getData(leadId) {
        let dataError = true;
        try {
            if (drawerPage === "CloneLead") {
                const responseData = await LeadDetailData(leadId);
                const response = responseData.data
                getSharingPermissions(undefined)
                setData(response);
                setLeadInitial(InitialData.LeadData)
                const transformedItem = {
                    ...response,
                    created_at: response.created_at ? convertAndFormatDateTime(response.created_time ? `${response.created_at} ${response.created_time}` : response.created_at, companyProfile, profile) : "",
                    modified_at: response.modified_at ? convertAndFormatDateTime(response.modified_time ? `${response.modified_at} ${response.modified_time}` : response.modified_at, companyProfile, profile) : "",
                };
                setDisplayData(transformedItem)
            } else {
                const responseData = await LeadDetailData(leadId);
                dataError = responseData.allow
                if (!responseData.allow) throw new Error();
                const response = responseData.data
                getSharingPermissions(response?.sharingPermission)
                setData(response);
                setInitialData(response)
                const transformedItem = {
                    ...response,
                    created_at: response.created_at ? convertAndFormatDateTime(response.created_time ? `${response.created_at} ${response.created_time}` : response.created_at, companyProfile, profile) : "",
                    modified_at: response.modified_at ? convertAndFormatDateTime(response.modified_time ? `${response.modified_at} ${response.modified_time}` : response.modified_at, companyProfile, profile) : "",
                };
                setDisplayData(transformedItem)
            }
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: dataError ? 'error' : 'info',
                content: dataError ? `This record is no longer available. It may have been deleted or moved` : "You don’t have permission to view this record. Please contact your administrator for access",
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: dataError ? 'error' : 'info',
                        content: dataError ? `This record is no longer available. It may have been deleted or moved` : "You don’t have permission to view this record. Please contact your administrator for access",
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    async function getData1(leadId, hideMessage, isAutomation, updateResponse) {
        let dataError = true;
        try {
            const responseData = await LeadDetailData(leadId);
            hideMessage();
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Lead <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            dataError = responseData.allow
            if (!responseData.allow) throw new Error();
            const response = responseData.data
            getSharingPermissions(response?.sharingPermission)
            setData(response);
            setInitialData(response)
            const transformedItem = {
                ...response,
                created_at: response.created_at ? convertAndFormatDateTime(response.created_time ? `${response.created_at} ${response.created_time}` : response.created_at, companyProfile, profile) : "",
                modified_at: response.modified_at ? convertAndFormatDateTime(response.modified_time ? `${response.modified_at} ${response.modified_time}` : response.modified_at, companyProfile, profile) : "",
            };
            setDisplayData(transformedItem)
            setTrigger("activity")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
        } catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Lead <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: dataError ? 'error' : 'info',
                content: dataError ? `This record is no longer available. It may have been deleted or moved` : "You don’t have permission to view this record. Please contact your administrator for access",
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: dataError ? 'error' : 'info',
                        content: dataError ? `This record is no longer available. It may have been deleted or moved` : "You don’t have permission to view this record. Please contact your administrator for access",
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted();
    async function getEntityAvalibitlity() {
        let dataFound = true;
        try {
            const response = await NavigationDecrypted(UrlId[1])
            if (response) {
                setLeadId(response)
                dataFound = true;
                getData(response)
            }
            else {
                dataFound = false;
            }
        } catch (error) {
            dataFound = false;
        }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const handleCountryChange = async (value, option) => {
        setCountry(value);
        if (option.key) {
            try {
                const response = await getStateData(option.key)
                setAllState(response);
                setState()
                setCity()
                setAllCity([])
            } catch (error) {
                message.error(error)
            }
        } else {
            setAllState([]);
            setAllCity([])
            setState()
            setCity()
        }
    }
    const handleStateChange = async (value, option) => {
        setState(value);
        if (option.key) {
            try {
                const response = await getCityData(option.key)
                setAllCity(response);
                setCity()
            } catch (error) {
                message.error(error)
            }
        }
        else {
            setAllCity([]);
            setCity()
        }
    }
    const handleCityChange = (value) => {
        setCity(value)
    }
    const handleChange = (value) => {
        setChecked(value)
    }
    useEffect(() => {
        if (FromPage) {
            scroolup();
            getLeadStatus()
        }
    }, [FromPage])
    const fetchAll = async () => {
        await Promise.allSettled([
            getCountry(),
            getRatingData(),
            getAnnualRevenueData(),
            getNomEmployeeData(),
            getTitleData(),
            UserDetailsApi(),
            getLeadsource(),
            getSeniorityLevel(),
            IndustryDataApi(),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll()
        }
    }, [FromPage, editField, displayData])
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const handleNoteClick = (value) => {
        setNotePopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
        setPage("Entity")
    }
    const handleCallLogClick = (value) => {
        setCallLogPopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
    }
    const AssignToFucntion = () => {
        if (approveCondition) { setApproveOpen(true) }
        else {
            setValues([leadId])
            setPopup(true)
            setPopupType("Change Owner")
            setAction("SingleChangeOwner")
        }
    }
    const HandleAddCampaignClick = () => {
        if (!proAllowed) {
            blockPro(PRO_FEATURE_NAMES.SEGMENTS);
            return;
        }
        setCampaignPopup(true)
    }
    const HandleAddOutreachClick = () => {
        if (!proAllowed) {
            blockPro(PRO_FEATURE_NAMES.OUTREACH);
            return;
        }
        setOutreachPopup(true)
    }
    const HandleShareClick = () => {
        setSharePopup(true)
    }
    const CloneLead = () => {
        setDrawerPage("CloneLead")
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            if (profile.department === "Sales") {
                form.setFieldsValue({
                    leadOwner: profile.userId
                });
            }
        }
    }
    useEffect(() => {
        const currentUrlId = JSON.stringify(UrlId); // <-- serialize for comparison
        const currentFromPage = FromPage;
        const isCloneLead = drawerPage === "CloneLead";
        if (
            !isCloneLead &&
            prevValues.current.UrlId === currentUrlId &&
            prevValues.current.FromPage === currentFromPage
        ) {
            return;
        }
        prevValues.current = {
            UrlId: currentUrlId,
            FromPage: currentFromPage,
        };
        if (FromPage) {
            if (FromPage === "EntityUpdate") {
                if (drawerPage === "CloneLead") {
                    getData(leadId)
                    setDataPermissions("Read,Update,Delete,Sharing")
                    setEditField(true)
                    setEdit(true)
                }
                else {
                    getEntityAvalibitlity()
                }
            }
            else {
                const fullName = MailData?.from?.name?.trim() || "";
                const [mailFirstName, ...mailLastName] = fullName.split(" ");
                form.setFieldsValue({
                    firstName: fromEmail === "fromEmail" ? mailFirstName : undefined,
                    lastName: fromEmail === "fromEmail" ? mailLastName.join(" ") : undefined,
                    leadOwner: undefined,
                    // description: undefined,
                    postcode: undefined,
                    street: undefined,
                    accountName: undefined,
                    secondaryEmail: undefined,
                    leadStatus: undefined,
                    leadSource: undefined,
                    mobile: undefined,
                    fax: undefined,
                    phone: undefined,
                    primaryEmail: (fromEmail === "fromEmail" ? MailData?.from?.email : undefined),
                    title: "Mr.",
                    designation: (fromEmail === "fromEmail" ? MailData?.from?.designation : undefined),
                    annualrevenue: undefined,
                    websiteName: undefined,
                    noofemployees: undefined,
                    industry: undefined,
                    rating: undefined,
                    seniorityLevel: undefined,
                    country: undefined,
                    linkedinUrl: undefined,
                    tags: undefined
                })
                setContent1()
                setContent2()
                setFileList([])
                setImage()
                setDeleteOpen()
                setChecked(false)
                setLeadId()
                setStates({
                    ...states,
                    selectedRowKeys: []
                });
                setCountry()
                setState()
                setCity()
                getUserDetail()
                setDisplayData("Create")
                setRelatedLead()
                setLeadInitial(InitialData.LeadData)
                setDataPermissions("Read,Update,Delete,Sharing")
                setEdit(true)
                setEditField(true)
                setAccount([])
            }
        }
    }, [UrlId, FromPage, drawerPage]);
    const FileUpload = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: '.png,.jpg,.jpeg',
        beforeUpload: (file) => {
            const allowedTypes = ['image/png', 'image/jpeg'];
            if (!allowedTypes.includes(file.type)) {
                message.error('Only PNG, JPG and JPEG images are allowed');
                return false;
            }
            const maxSize = 100 * 1024;
            if (file.size > maxSize) {
                message.error('Image size must be 100 KB or less');
                return false;
            }
            return true;
        },
        customRequest: async ({ file, onSuccess, onError }) => {
            const hideUploadMessage = message.loading("Uploading profile picture...", 0);
            setImageUploading(true);
            try {
                const formData = new FormData();
                formData.append("file", file);
                const response = await getAxiosInstance().post(
                    "/usermgmt/uploadFile",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                onSuccess(response.data);
            } catch (error) {
                onError(error);
            } finally {
                hideUploadMessage();
                setImageUploading(false);
            }
        },
        onChange(info) {
            const { status } = info.file;
            if (status === 'done') {
                setImage(info.file.response.mediaUrl);
                setDeleteOpen(true)
                message.success(`${info.file.name} File upload successful`);
            } else if (status === 'error') {
                message.error(`${info.file.name} File upload failed`);
            }
        },
        listType: 'picture',
        showUploadList: false,
    };
    const handleDeleteImage = () => {
        setImage(null);
        setDeleteOpen(false);
    };
    const closeMailComposr = () => {
        setMailOpen(false);
    };
    const CreateTask = (id) => {
        setCreatePageTask("ListingLead")
        setNaCTrigger("trigger")
        setTaskProp({
            type: "Lead",
            ids: [id]
        })
    }
    const CreateMail = () => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            setNaCTrigger("trigger")
            setMailOpen(true)
        }
    }
    const CreateMeeting = (LId, firstname, lastname, mail) => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            setMeetingAttendees([{
                id: LId,
                name: `${firstname} ${lastname}`,
                type: "Leads",
                email: mail,
            }])
            setNaCTrigger("trigger")
            setMeetingOpen(true)
        }
    }
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    // const onSelect = (value) => {
    //     form.setFieldsValue({
    //         accountName: value
    //     })
    // };
    const handleEditChange = () => {
        if (approveCondition) {
            setApproveOpen(true)
        }
        else {
            setEditField(true)
            setEdit(true)
            dispatch(setEditCall(true))
            setTrigger("");
            setApproveOpen(false)
        }
    }
    const handleConvertChange = () => {
        if (approveCondition) {
            setApproveOpen(true)
        }
        else {
            ConvertApi(leadId)
            setApproveOpen(false)
        }
    }
    const handleMergeclick = () => {
        if (approveCondition) {
            setApproveOpen(true)
            setMergeOpen(false)
        }
        else {
            setNaCTrigger("trigger")
            setApproveOpen(false)
            setMergeOpen(true)
        }
    }
    const moreAction = "Yes"
    const MoreAction = ({ closeDropdown }) => (
        <div style={{
            padding: "0px",
            width: "100%",
            height: "100%",
        }}>
            <Link to={combinedUrl}
                onClick={(edit || !canCreate(permissions, 2002)) ? undefined : () => { CloneLead(); closeDropdown() }}
                className={`text_icon ${(edit || !canCreate(permissions, 2002)) ? "disabled_link" : ''}`}>
                <CloneIcon height={15} width={15} marginRight={5} /> Clone
            </Link>
            {/* <Link to={combinedUrl} onClick={(edit || !canShare(dataPermissions, "Sharing")) ? undefined : () => { HandleShareClick(); closeDropdown() }} className={`text_icon ${(edit || !canShare(dataPermissions, "Sharing")) ? 'disabled_link' : ""}`}>
                <ShareIcon height={14} width={14} marginRight={5} /> Share
            </Link> */}
            <Link to={combinedUrl} onClick={(edit || (profile.userId !== displayData?.lead_owner)) ?
                undefined : () => { HandleShareClick(); closeDropdown() }}
                className={`text_icon ${(edit || (profile.userId !== displayData?.lead_owner)) ? 'disabled_link' : ""}`}>
                <ShareIcon height={14} width={14} marginRight={5} /> Share
            </Link>
            <Link to={combinedUrl} onClick={(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2003)) ? () => { AssignToFucntion(); closeDropdown() } : undefined} className={`text_icon ${(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2003)) ? "" : 'disabled_link'}`}>
                <ChangeOwnerIcon height={15} width={15} marginRight={5} /> Change Owner
            </Link>
            <Link to={combinedUrl} onClick={(edit || !canCreate(permissions, 2002)) ? undefined : () => { handleNoteClick("Create"); closeDropdown() }} className={`text_icon ${(edit || !canCreate(permissions, 2002)) ? "disabled_link" : ''}`}>
                <NotesIcon height={15} width={15} marginRight={5} /> Add a Note
            </Link>
            <Link to={combinedUrl} onClick={(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2003)) ? () => { handleMergeclick(); closeDropdown() } : undefined} className={`text_icon ${(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2003)) ? "" : 'disabled_link'}`}>
                <MergeIcon height={15} width={15} marginRight={5} /> Merge Duplicates
            </Link>
            <Link to={combinedUrl}
                onClick={(edit || !canCreate(permissions, 2002)) ? undefined : () => { HandleAddCampaignClick(); closeDropdown() }}
                className={`text_icon ${(edit || !canCreate(permissions, 2002)) ? "disabled_link" : ''}`}>
                <SegmentIcon height={15} width={15} marginRight={5} /> Add to Segments
            </Link>
            {(assignOwner === profile.userId && displayData.email_opt_out !== 1 && displayData.email_opt_out !== true) ? <Link to={combinedUrl}
                onClick={(edit || !canCreate(permissions, 2002)) ? undefined : () => { HandleAddOutreachClick(); closeDropdown() }}
                className={`text_icon ${(edit || !canCreate(permissions, 2002)) ? "disabled_link" : ''}`}>
                <EmailseqQueueIcon height={15} width={15} marginRight={5} /> Add to Outreach Sequence
            </Link> : <></>}
        </div >
    );
    MoreAction.propTypes = {
        closeDropdown: PropTypes.func.isRequired,
    };
    const ButtonActions = [
        {
            Actions: <div className={(!canCreate(permissions, 2002)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Send Email'
                onClick={(!canCreate(permissions, 2002)) ? undefined : () => CreateMail()}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2002) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateMail()
                    }
                }}
                aria-label='mail'
            > <EmailIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2002)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Schedule a Meeting'
                onClick={(!canCreate(permissions, 2002)) ? undefined : () => CreateMeeting(leadId, displayData?.first_name, displayData?.last_name, displayData?.primary_email)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2002) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateMeeting(leadId, displayData?.first_name, displayData?.last_name, displayData?.primary_email)
                    }
                }}
                aria-label='meeting'
            > <CalendarIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2002)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Create Task'
                onClick={(!canCreate(permissions, 2002)) ? undefined : () => CreateTask(leadId)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2002) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateTask(leadId)
                    }
                }}
                aria-label='task'
            > <TaskIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2002)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Log a Call'
                onClick={(!canCreate(permissions, 2002)) ? undefined : () => handleCallLogClick("Create")}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2002) && (event.key === 'Enter' || event.key === ' ')) {
                        handleCallLogClick("Create")
                    }
                }}
                aria-label='phone'
            > <CallLogIcon height={20} width={20} /></div>
        },
    ]
    const LeadInfos = {
        profile: image,
        Classname: "LeadIcon",
        letterIcon: displayData?.first_name,
        name: `${displayData?.title ? displayData?.title : ""} ${displayData?.first_name} ${displayData?.last_name}`,
        subName: displayData?.designation && displayData?.designation !== "" ? displayData?.designation : "Designation",
        mainAction: <>
            <Button className="button_colors" size="small" style={{ width: "60%" }} onClick={canUpdateDelete(permissions, dataPermissions, "Update", 2003) ? () => handleConvertChange() : undefined} disabled={!canUpdateDelete(permissions, dataPermissions, "Update", 2003)}>
                <ConvertIcon height={25} width={25} /> Convert to Contact
            </Button>
        </>,
    }
    const EditOpenForDrawer = () => {
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        const { firstName, annualrevenue, tags, noofemployees, linkedinUrl, websiteName, seniorityLevel, industry, rating, designation, lastName, postcode, street, accountName, leadOwner, title, primaryEmail, phone, fax, mobile, leadSource, leadStatus, secondaryEmail } = values;
        const allTags = tags?.join(",") || ""
        const payload =
        {
            seniorityLevelId: normalizeValue(seniorityLevel),
            firstName: normalizeValue(firstName),
            lastName: normalizeValue(lastName),
            leadOwner: normalizeValue(leadOwner),
            designation: normalizeValue(designation),
            accountName: normalizeValue(accountName),
            industry: normalizeValue(industry),
            rating: normalizeValue(rating),
            nomOfEmployees: normalizeValue(noofemployees),
            title: normalizeValue(title),
            primaryEmail: normalizeValue(primaryEmail),
            secondaryEmail: normalizeValue(secondaryEmail),
            phone: normalizeValue(phone),
            mobile: normalizeValue(mobile),
            leadSourceId: normalizeValue(leadSource),
            leadStatusId: normalizeValue(leadStatus),
            emailOptOut: normalizeValue(checked),
            fax: normalizeValue(fax),
            description: normalizeValue(content1),
            accountDescription: normalizeValue(content2),
            leadProfile: normalizeValue(image),
            leadFiles: FILEList,
            city: normalizeValue(city),
            street: normalizeValue(street),
            country: normalizeValue(country),
            postcode: normalizeValue((postcode && postcode !== "") ? Number(postcode) : undefined),
            state: normalizeValue(state),
            annualRevenue: normalizeValue(annualrevenue),
            website: normalizeValue(websiteName),
            linkedinUrl: normalizeValue(linkedinUrl),
            relatedLeadId: normalizeValue(relatedLead),
            tags: normalizeValue(allTags)
        }
        const updatedFields = getChangedFields(payload, leadInitial);
        if (Object.keys(updatedFields).length === 0) {
            getData(leadId)
            scroolup()
            message.success("Lead updated")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
            return;
        }
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
                const response = await LeadUpdate(updatedFields, leadId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        loadingRef.current = false;
                        setDoubleClick(false)
                        hideMessage();
                    }
                    else {
                        const isAutomation = response.data[0].message === AutomationMessage;
                        const isApproval = response.data[0].message === ApprovalMessage;
                        const ownerChanged = displayData?.lead_owner !== leadOwner;
                        if (isApproval) {
                            hideMessage();
                            getData(leadId)
                            scroolup()
                            successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                            loadingRef.current = false;
                            setDoubleClick(false)
                            CloseDrawerNew()
                        }
                        else if (ownerChanged) {
                            hideMessage();
                            if (isAutomation) {
                                successMessage("Automation rule triggered", response.data[0].message);
                            } else {
                                message.success(
                                    <span>
                                        Lead <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                    </span>
                                );
                            }
                            dispatch(setEditCall(false));
                            history.push('/Home/leads');
                        }
                        else {
                            getData1(leadId, hideMessage, isAutomation, response)
                            scroolup();
                        }
                    }
                }
            }
            else {
                const response = await LeadSave(updatedFields)
                if (response.status === 201) {
                    const isAutomation = response?.data?.message === AutomationMessage;
                    const isApproval = response?.data?.message === ApprovalMessage;
                    hideMessage();
                    if (isApproval) {
                        successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                    } else if (isAutomation) {
                        successMessage("Automation rule triggered", response?.data?.message);
                        if (fromEmail === "fromEmail") {
                            CallBack(response.data.leadId)
                        }
                    } else {
                        message.success(response?.data?.message);
                        if (fromEmail === "fromEmail") {
                            CallBack(response.data.leadId)
                        }
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer();
                }
            }
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error)
        }
    }
    const onSubmitClone = (value) => {
        if (displayData.account_name !== value.accountName) {
            Modal.confirm({
                icon: null,
                className: "customice-confirm-modal",
                title: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                        <span>Account Changed</span>
                    </div>
                ),
                content: (
                    <div>
                        <p>You are modifying the account name for this lead only. If other leads use the same account, their account names must be updated manually.</p>
                    </div>
                ),
                centered: true,
                okText: "Continue",
                cancelText: "Cancel",
                okButtonProps: {
                    className: "button_colorsModal"
                },
                cancelButtonProps: {
                    className: "gray-buttonModal"
                },
                // okCancel: true,
                onOk() {
                    onSubmit(value);
                },
                onCancel() {
                    scroolup()
                    getData(leadId)
                },
            });
        } else {
            onSubmit(value);
        }
    }
    const CloseDrawer2 = () => {
        scroolup();
        getData(leadId)
        setEditField(false)
        setEdit(false);
        dispatch(setEditCall(false))
        setDrawerPage()
    }
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
            CloseDrawer2()
        }
        else if (FromPage === "EntityUpdate" && drawerPage === "CloneLead") {
            setCancelConfirmOpen(true)
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const getRefreshtheTable = () => {
        CloseDrawer2()
        setTrigger("activity")
    }
    useEffect(() => {
        if (account.length && displayData?.account_name) {
            const matched = account.find(acc => acc.value === displayData.account_name);
            if (matched) {
                setDataDisables({
                    isDisable: matched.data.status === "Qualified",
                    allow: matched.data.status === "Qualified",
                    id: matched.data.accountID,
                    profile: matched.data.accountProfile
                });
            } else {
                setDataDisables({
                    isDisable: false,
                    allow: false,
                    id: null,
                    profile: null
                })
            }
        }
    }, [displayData, account]);
    const normalizeValue2 = (value) => value?.toLowerCase()?.trim() || '';
    const getSeniorityLevelId = (senioritys) => {
        const normalized = normalizeValue2(senioritys);
        const match = seniority.find(item =>
            item.seniorityLevel.toLowerCase().includes(normalized)
        );
        return match || null;
        // return match?.seniorityLevelId || null;
    };
    const attributes = [
        { key: "first_name", label: "First Name" },
        { key: "last_name", label: "Last Name" },
        { key: "primary_email", label: "Primary Email" },
        { key: "designation", label: "Designation" },
        { key: "seniority_level", label: "Seniority Level" },
        { key: "linkedin_url", label: "Linkedin Url" },
        { key: "country", label: "Country" },
        { key: "state", label: "State" },
        { key: "city", label: "City" },
    ];
    const updateEnrichdata = async (value) => {
        form.setFieldsValue({
            firstName: value.first_name,
            lastName: value.last_name,
            primaryEmail: value.primary_email,
            designation: value.designation,
            seniorityLevel: value.seniority_level_id,
            country: value.country,
            linkedinUrl: value.linkedin_url,
        })
        setCountry(value.country)
        message.success("Enrichment completed. Please update the lead to save the changes")
        try {
            const response = await getCountryData()
            if (value.country) {
                const countryInfo = response.find(countrys => countrys.country === value.country);
                if (countryInfo) {
                    const iso = countryInfo.countryId
                    getState(value, iso)
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    const showConfirm2 = (newStructure) => {
        const tableData = attributes.map((attr, index) => ({
            key: index,
            attribute: attr.label,
            oldValue: displayData?.[attr.key] ?? "-",
            enrichedValue: newStructure?.[attr.key] ?? "-",
        }));
        const columnss = [
            {
                title: "Attribute",
                dataIndex: "attribute",
                key: "attribute",
                width: "30%",
                ellipsis: true,
                render: (text) => (
                    <Typography.Paragraph
                        ellipsis={{ tooltip: text }}
                        style={{ marginBottom: 0 }}
                    >
                        {text}
                    </Typography.Paragraph>
                ),
            },
            {
                title: "Lead Data",
                dataIndex: "oldValue",
                key: "oldValue",
                width: "35%",
                ellipsis: true,
                render: (text) => (
                    <Typography.Paragraph
                        ellipsis={{ tooltip: text }}
                        style={{ marginBottom: 0 }}
                    >
                        {text}
                    </Typography.Paragraph>
                ),
            },
            {
                title: "Enriched Data",
                dataIndex: "enrichedValue",
                key: "enrichedValue",
                width: "35%",
                ellipsis: true,
                render: (text) => (
                    <Typography.Paragraph
                        ellipsis={{ tooltip: text }}
                        style={{ marginBottom: 0 }}
                    >
                        {text}
                    </Typography.Paragraph>
                ),
            },
        ];
        const modal = Modal.confirm({
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span>Lead Enrichment</span>
                </div>
            ),
            icon: null,
            width: 1000,
            content: (
                <div>
                    <p>Are you sure, you want to add enriched data?</p>
                    <div className="table-bordered leaderboard-table table-responsive">
                        <Table
                            dataSource={tableData}
                            columns={columnss}
                            rowKey={(record, index) => index?.toString()}
                            pagination={false}
                            tableLayout="fixed"
                        />
                    </div>
                </div>
            ),
            className: "customice-confirm-modal",
            centered: true,
            okText: "Enrich",
            cancelText: "Cancel",
            okButtonProps: {
                className: "button_colorsModal"
            },
            cancelButtonProps: {
                className: "gray-buttonModal"
            },
            okCancel: true,
            onOk() {
                updateEnrichdata(newStructure)
            },
            onCancel() {
                modal.destroy();
            },
        });
    };
    async function ConnectwithLead(paramsEmail) {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        try {
            hideMessage = message.loading("Collecting lead information...", 0);
            const response = await hunterioLeadDetails(profile.companyId, paramsEmail)
            const LeadData = response.data
            const seniorityLevel = getSeniorityLevelId(LeadData?.employment?.seniority);
            const newStructure = {
                "first_name": LeadData?.name?.givenName ? LeadData?.name?.givenName : displayData?.first_name,
                "last_name": LeadData?.name?.familyName ? LeadData?.name?.familyName : displayData?.last_name,
                "primary_email": LeadData?.email ? LeadData?.email : displayData?.primary_email,
                "designation": LeadData?.employment?.title ? LeadData?.employment?.title : displayData?.designation,
                "seniority_level_id": seniorityLevel?.seniorityLevelId ? seniorityLevel?.seniorityLevelId : displayData?.seniority_level_id,
                "seniority_level": seniorityLevel?.seniorityLevel ? seniorityLevel?.seniorityLevel : displayData?.seniority_level,
                "linkedin_url": LeadData?.linkedin?.handle ? `https://www.linkedin.com/in/${LeadData?.linkedin?.handle}` : null,
                "country": LeadData?.geo?.country ? LeadData?.geo?.country : displayData?.country,
                "state": LeadData?.geo?.state ? LeadData?.geo?.state : null,
                "city": LeadData?.geo?.city ? LeadData?.geo?.city : null
            }
            message.success("Lead enriched successful")
            loadingRef.current = false;
            setDoubleClick(false)
            hideMessage();
            showConfirm2(newStructure)
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error)
        }
    }
    const handleFinish = (values) => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
            onSubmitClone(values);
        } else {
            onSubmit(values);
        }
    };
    const memoUrlId = useMemo(() => (UrlId ? [UrlId[0], leadId] : null), [UrlId, leadId]);
    const updatePsqq = useMemo(() => ({
        permission: permissions,
        dataPermission: dataPermissions,
        type: "Update",
        PId: 2003,
    }), [permissions, dataPermissions]);
    const getDetailsDatas = useCallback(() => getData(leadId), [leadId]);
    const MemoLeadStatusBar = useMemo(() => (
        <LeadStatusBar UrlId={memoUrlId} getDetailsData={getDetailsDatas} leadStatusData={leadStatusData} displayData={displayData} setNaCTrigger={setNaCTrigger} canUpdateDelete={canUpdateDelete}
            UpdatePs={updatePsqq} successMessage={successMessage} ApprovalMessage={ApprovalMessage} AutomationMessage={AutomationMessage}
            setErrorData={setErrorData} setIsModalVisible1={setIsModalVisible1} setTrigger={setTrigger} />
    ), [
        memoUrlId,
        getDetailsDatas,
        leadStatusData,
        displayData,
        setNaCTrigger,
        canUpdateDelete,
        updatePsqq,
        successMessage,
        ApprovalMessage,
        AutomationMessage,
        setErrorData,
        setIsModalVisible1,
        setTrigger
    ]);
    const MemoLeadFields = useMemo(() => (
        <LeadFields displayData={displayData} setNaCTrigger={setNaCTrigger} />
    ), [displayData, setNaCTrigger]);
    const MemoRelatedTab = useMemo(() => (
        <RelatedTab EntityType="Lead" UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailapiValues} trigger={trigger} />
    ), [memoUrlId, NacTrigger, setNaCTrigger, profile, emailapiValues, trigger]);
    const MemoRightRelatedData = useMemo(() => (
        <LeadRightData displayData={displayData} dataDisables={dataDisables} profile={profile} ViewDetailPage={ViewDetailPage} Role={Role} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} trigger={trigger} />
    ), [displayData, dataDisables, profile, ViewDetailPage, Role, memoUrlId, NacTrigger, setNaCTrigger, trigger]);
    const PAGE_SIZE = 50;
    const [hasMoreTags, setHasMoreTags] = useState(true);
    const [tagsDropdownOpen, setTagsDropdownOpen] = useState(false);
    const tagsPopupRef = useRef(null);
    const fetchedCountRef = useRef(0);
    const [loadingList, setLoadingList] = useState(false)
    const [tagOptions, setTagOptions] = useState([])
    const [pagess, setPages] = useState(1)
    const fetchNextPage = async () => {
        if (loadingList || !hasMoreTags) return;
        setLoadingList(true);
        try {
            let response;
            if (isRestricted) {
                response = await AllLeadPaginationByDep(pagess, PAGE_SIZE);
            } else {
                response = await AllLeadPagination(pagess, PAGE_SIZE);
            }
            const items = response?.items || [];
            const total = response?.total ?? 0;
            fetchedCountRef.current += items.length;
            if (fetchedCountRef.current >= total) {
                setHasMoreTags(false);
            }
            setTagOptions((prev) => {
                const tags = new Set(prev.map((t) => t.value));
                items.forEach((lead) => {
                    if (!lead.tags) return;
                    lead.tags
                        .split(",")
                        .map((tag) => tag.trim())
                        .filter(Boolean)
                        .forEach((tag) => tags.add(tag));
                });
                return [...tags].sort().map((tag) => ({ label: tag, value: tag }));
            });
            setPages((prev) => prev + 1);
        } finally {
            setLoadingList(false);
        }
    };
    const handlePopupScroll = (e) => {
        const targets = e.target;
        if (
            targets.scrollTop + targets.clientHeight >= targets.scrollHeight - 10 &&
            !loadingList &&
            hasMoreTags
        ) {
            fetchNextPage();
        }
    };
    useEffect(() => {
        if (FromPage) {
            if (!tagsDropdownOpen || !hasMoreTags || loadingList) return undefined;
            const el = tagsPopupRef.current;
            if (!el) return undefined;

            const id = requestAnimationFrame(() => {
                if (el.scrollHeight <= el.clientHeight) {
                    fetchNextPage();
                }
            });
            return () => cancelAnimationFrame(id);
        }
    }, [tagsDropdownOpen, tagOptions, hasMoreTags, loadingList, FromPage]);
    const handleChange1 = (val) => {
        setContent1(val);
    };
    const handleChange2 = (val) => {
        setContent2(val);
    };

    // const AI_ALLOWED_TAGS = new Set(['div', 'p', 'span', 'strong', 'b', 'em', 'i', 'u', 'h1', 'h2', 'h3', 'h4', 'ul', 'ol', 'li', 'br']);
    // const AI_ALLOWED_STYLE_PROPS = new Set([
    //     'color', 'font-weight', 'font-style', 'font-size', 'text-decoration',
    //     'border-bottom', 'padding-bottom', 'margin-bottom', 'display', 'line-height',
    // ]);
    // const escapeHtml = (text) =>
    //     String(text)
    //         .replace(/&/g, '&amp;')
    //         .replace(/</g, '&lt;')
    //         .replace(/>/g, '&gt;');
    // const extractAiText = (res) => {
    //     const d = res?.data ?? res;
    //     if (typeof d === 'string') return d;
    //     const candidate = d?.description ?? d?.accountDescription ?? d?.result ?? d?.content ?? d?.data;
    //     if (typeof candidate === 'string') return candidate;
    //     if (candidate && typeof candidate === 'object') {
    //         return candidate.description ?? candidate.accountDescription ?? candidate.content ?? '';
    //     }
    //     return '';
    // };
    // const filterStyleDecls = (declString) =>
    //     String(declString || '')
    //         .split(';')
    //         .map((d) => d.split(/:(.+)/).map((x) => x && x.trim()))
    //         .filter(([prop, val]) =>
    //             prop && val &&
    //             AI_ALLOWED_STYLE_PROPS.has(prop.toLowerCase()) &&
    //             !/url\(|expression\(|javascript:/i.test(val))
    //         .map(([prop, val]) => `${prop}:${val}`)
    //         .join(';');
    // const parseCssRules = (css) =>
    //     Array.from(String(css || '').matchAll(/([^{}]+)\{([^{}]*)\}/g)).flatMap(([, selectorList, body]) => {
    //         const decls = filterStyleDecls(body);
    //         if (!decls) return [];
    //         return selectorList
    //             .split(',')
    //             .map((selector) => selector.trim())
    //             .filter(Boolean)
    //             .map((selector) => ({ selector, decls }));
    //     });
    // const sanitizeAiNode = (root) => {
    //     Array.from(root.children).forEach((el) => {
    //         sanitizeAiNode(el);
    //         const tag = el.tagName.toLowerCase();
    //         if (!AI_ALLOWED_TAGS.has(tag)) {
    //             el.replaceWith(...Array.from(el.childNodes));
    //             return;
    //         }
    //         const style = filterStyleDecls(el.getAttribute('style'));
    //         Array.from(el.attributes).forEach((a) => el.removeAttribute(a.name));
    //         if (style) el.setAttribute('style', style);
    //     });
    // };
    // const aiHtmlToEditorHtml = (raw) => {
    //     let input = String(raw ?? '')
    //         .replace(/```(?:html)?/gi, '')
    //         .trim();
    //     if (!input) return '';

    //     // Plain-text answer (no markup): one <div> per line
    //     if (!/<[a-z!][^>]*>/i.test(input)) {
    //         return input.split(/\n+/).filter(Boolean).map((l) => `<div>${escapeHtml(l)}</div>`).join('');
    //     }

    //     // Drop any chatty preamble that appears before the actual HTML document
    //     const docStart = input.search(/<!DOCTYPE|<html/i);
    //     if (docStart > 0) input = input.slice(docStart);

    //     const doc = new DOMParser().parseFromString(input, 'text/html');

    //     // 1) Collect CSS from <style> tags
    //     const css = Array.from(doc.querySelectorAll('style')).map((s) => s.textContent).join('\n');

    //     // 2) Inline each rule on its matching elements (html/body skipped: they are the page wrapper)
    //     parseCssRules(css).forEach(({ selector, decls }) => {
    //         if (/^(html|body|\*)$/i.test(selector)) return;
    //         try {
    //             doc.body.querySelectorAll(selector).forEach((el) => {
    //                 const existing = el.getAttribute('style');
    //                 el.setAttribute('style', existing ? `${existing};${decls}` : decls);
    //             });
    //         } catch (e) { /* ignore selectors the browser can't parse */ }
    //     });

    //     // 3) Remove non-content elements, then sanitize what is left
    //     doc.querySelectorAll('script, style, head, noscript, template, iframe, object, embed').forEach((el) => el.remove());
    //     sanitizeAiNode(doc.body);

    //     return doc.body.innerHTML.trim();
    // };

    const hasEditorContent = (html) =>
        !!html && html.replace(/<[^>]*>|&nbsp;|\s/g, '') !== '';
    const appendAiContent = (existing, generated) =>
        hasEditorContent(existing)
            ? `${existing}<div><br></div>${generated}`
            : generated;
    const runAiGeneration = async (targetCompany, targetCompanyDomain) => {
        setAiLoading(true);
        try {
            const response = await generateAccountDescription({ targetCompany, targetCompanyDomain });
            const html = response?.data?.html;
            if (!html) {
                message.error('No description was generated. Please try again.');
                return;
            }
            setContent2((prev) => appendAiContent(prev, html));
        } catch (error) {
            message.error(error?.message || 'Failed to generate description');
        } finally {
            setAiLoading(false);
        }
    };
    const generateAiDescription = () => {
        const targetCompany = form.getFieldValue('accountName')?.trim();
        const targetCompanyDomain = form.getFieldValue('websiteName')?.trim();
        if (!targetCompany || !targetCompanyDomain) {
            message.warning('Please enter Account Name and Account Url first');
            return;
        }
        // the API is triggered only after the user confirms with OK
        const modal = Modal.confirm({
            icon: null,
            className: "customice-confirm-modal",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span>Generate Description with AI</span>
                </div>
            ),
            content: (
                <p>The AI-generated description will be appended to the existing description. Do you want to continue?</p>
            ),
            centered: true,
            okText: "OK",
            cancelText: "Cancel",
            okButtonProps: { className: "button_colorsModal" },
            cancelButtonProps: { className: "gray-buttonModal" },
            onOk() {
                runAiGeneration(targetCompany, targetCompanyDomain);
            },
            onCancel() {
                modal.destroy();
            },
        });
    };
    return (
        <>
            {FromPage === "EntityUpdate" ?
                <Main>
                    {displayData ? <>
                        {FromPage === "EntityUpdate" &&
                            <DetailsPage PageCancel={PageCancel}
                                handleEditChange={handleEditChange}
                                canUpdateDelete={canUpdateDelete} entity="Lead"
                                UpdatePs={{ permission: permissions, dataPermission: dataPermissions, type: "Update", PId: 2003 }}
                                moreAction={moreAction}
                                DetailsPageMoreAction={<MoreAction />}
                                ButtonActions={ButtonActions}
                                Maincontent={LeadInfos}
                                UpdateDataPage={MemoLeadStatusBar}
                                EntityTabDetails={MemoLeadFields}
                                EntityRelatedTab={MemoRelatedTab}
                                RightRelatedDetails={MemoRightRelatedData}
                            />}
                    </>
                        :
                        <div className="spin">
                            <Spin />
                        </div>}
                </Main> : <></>}
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        drawerPage === "CloneLead" ? "Clone Lead" :
                            <span>
                                Update Lead
                                {(displayData?.first_name || displayData?.last_name) && (
                                    <>
                                        <span style={{
                                            margin: '0 10px',
                                            color: '#d9d9d9',
                                            fontWeight: 'normal'
                                        }}>|</span>
                                        <span style={{ fontWeight: 'normal' }}>
                                            {`${displayData?.first_name || ''} ${displayData?.last_name || ''}`.trim()}
                                        </span>
                                    </>
                                )}
                            </span>
                        : "Create Lead"}
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        {!edit ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => EditOpenForDrawer()}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        EditOpenForDrawer()
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={
                    (edit && uiReady) ? [
                        <div className="form_action_button">
                            <Button
                                className="gray-button" size="small"
                                onClick={() => PageCancel1()}
                            >
                                <CancelIcon height={25} width={25} />Cancel
                            </Button>
                            {FromPage === "EntityUpdate" && drawerPage !== "CloneLead" ?
                                <Button disabled={!canUpdateDelete(permissions, dataPermissions, "Delete", 2004) || deleteClick || doubleClick}
                                    className="red-button" size="small" loading={deleteClick} onClick={() => deleteMenu(leadId)}
                                >
                                    {!deleteClick && <DeleteIcon height={25} width={25} />}Delete
                                </Button> : <></>}
                            <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} loading={doubleClick} disabled={deleteClick || doubleClick}>
                                {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" && drawerPage !== "CloneLead" ? "Update" : "Save"}
                            </Button>
                        </div>] : false
                }
            >
                {(displayData && uiReady) ? <Scrollbars ref={scrollRef} autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form responsive-form-container">
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={handleFinish} onFinishFailed={onFinishFailed} colon={false}>
                                <BasicFormWrapper>
                                    <div className="add-product-block">
                                        <div style={{ margin: 40 }}>
                                            <Row gutter={15}> {/* className="responsive-form-grid" */}
                                                <Col xs={24}>
                                                    <div className="add-product-content">
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                            <Heading as="h5">Basic Information</Heading>
                                                            {(FromPage === "EntityUpdate" && drawerPage !== "CloneLead") ?
                                                                <div role="button" className="Hover-Refresh2 back-hover1 able-style"
                                                                    tabIndex={0}
                                                                    onClick={edit ? () => ConnectwithLead(displayData?.primary_email) : undefined}
                                                                    onKeyDown={(event) => {
                                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                                            ConnectwithLead(displayData?.primary_email)
                                                                        }
                                                                    }}>
                                                                    <QUSOINIcon height={16} width={16} marginRight={5} />Enrich Lead
                                                                </div> : <></>
                                                            }
                                                        </div>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Title" name="title" id="title" >
                                                                    <Select style={{ width: '100%' }} placeholder="Select Title" allowClear onChange={(value) => form.setFieldsValue({ title: value || null })} getPopupContainer={getFieldPopupContainer}>
                                                                        {title}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="First Name" name="firstName" id="firstName"
                                                                    rules={[{
                                                                        required: true,
                                                                        transform: (value) => value?.trim(), message: 'Please enter first name'
                                                                    }, {
                                                                        validator: (_, value) => {
                                                                            const error = nameOnChangeValidator(value, 25);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}>
                                                                    <Input placeholder="Enter First Name" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Last Name" name="lastName" id="lastName"
                                                                    rules={[{
                                                                        required: true,
                                                                        transform: (value) => value?.trim(), message: 'Please enter last name'
                                                                    }, {
                                                                        validator: (_, value) => {
                                                                            const error = nameOnChangeValidator(value, 25);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}>
                                                                    <Input placeholder="Enter Last Name" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Designation" name="designation"
                                                                    id="designation"
                                                                    rules={[{
                                                                        required: true,
                                                                        transform: (value) => value?.trim(), message: 'Please enter designation'
                                                                    }, {
                                                                        validator: (_, value) => {
                                                                            const error = validateTextField(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}>
                                                                    <Input placeholder="Enter designation" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Seniority Level" name="seniorityLevel"
                                                                    id="seniorityLevel" rules={[{ required: true, message: 'Please select a seniority level' }]}>
                                                                    <Select style={{ width: '100%' }} placeholder="Select Seniority Level"
                                                                        showSearch
                                                                        optionFilterProp="children" getPopupContainer={getFieldPopupContainer}
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }>
                                                                        {seniority.map((option, i) => (
                                                                            <Option value={option.seniorityLevelId} key={i}>
                                                                                {option.seniorityLevel}
                                                                            </Option>))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Primary Email" name="primaryEmail"
                                                                    id="primaryEmail" rules={[{
                                                                        required: true,
                                                                        transform: (value) => value?.trim(), message: 'Please enter primary email'
                                                                    }, {
                                                                        validator: (_, value) => {
                                                                            const error = validateEmailField(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]} >
                                                                    <Input placeholder="Enter Primary Email" disabled={fromEmail === "fromEmail"} />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Secondary Email" name="secondaryEmail"
                                                                    id="secondaryEmail" rules={[{
                                                                        validator: (_, value) => {
                                                                            const error = validateEmailField(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]} >
                                                                    <Input placeholder="Enter Secondary Email" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Phone" name="phone"
                                                                    id="phone" rules={[
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = mobileOnChangeValidator(value, 20);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]}>
                                                                    <Input placeholder="Enter Phone Number" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Fax" name="fax"
                                                                    id="fax" rules={
                                                                        [
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const error = mobileOnChangeValidator(value, 20);
                                                                                    if (error) {
                                                                                        return Promise.reject(new Error(error));
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                        ]
                                                                    }>
                                                                    <Input placeholder="Enter Fax Number" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Mobile" name="mobile"
                                                                    id="mobile" rules={
                                                                        [
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const error = mobileOnChangeValidator(value, 20);
                                                                                    if (error) {
                                                                                        return Promise.reject(new Error(error));
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                        ]
                                                                    }>
                                                                    <Input placeholder="Enter Mobile Number" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Linkedin Url" name="linkedinUrl" id="linkedinUrl"
                                                                    rules={
                                                                        [
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const error = validateLinkedInUrl(value);
                                                                                    if (error) {
                                                                                        return Promise.reject(new Error(error));
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                        ]
                                                                    }
                                                                >
                                                                    <Input placeholder="Enter Linkedin Url" />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Heading as="h5">Lead Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Lead Owner" name="leadOwner"
                                                                    id="leadOwner"
                                                                    rules={[{ required: true, message: 'Please select a lead owner', }]}>
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Lead Owner"
                                                                        showSearch getPopupContainer={getFieldPopupContainer}
                                                                        optionLabelProp="label"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }>
                                                                        {users}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Lead Source" name="leadSource"
                                                                    id="leadSource" rules={[{ required: true, message: 'Please select a lead source', }]}>
                                                                    <Select style={{ width: '100%' }} placeholder="Select Lead Source"
                                                                        showSearch getPopupContainer={getFieldPopupContainer}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }>
                                                                        {leadsource}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Lead Status" name="leadStatus"
                                                                    id="leadStatus" rules={[{ required: true, message: 'Please select a lead status', }]}>
                                                                    <Select style={{ width: '100%' }} placeholder="Select Lead Status"
                                                                        showSearch getPopupContainer={getFieldPopupContainer}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }>
                                                                        {leadStatus}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Email Opt Out?">
                                                                    <Checkbox
                                                                        checked={checked}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={30} style={{ margin: "0px 0px 20px" }}>
                                                            <Col span={24} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Description" >
                                                                    <TinyMCEEditor
                                                                        placeholder="Enter Description"
                                                                        content={content1}
                                                                        setContent={handleChange1}
                                                                        edit
                                                                        page="TextBoxs"
                                                                        height={150}
                                                                        selectedEntity="A"
                                                                    />
                                                                </Form.Item>
                                                                {/* <Form.Item label="Description" name="description" id="description" rules={
                                                                    [
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validateDescriptionField(value, 2500);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]
                                                                }>
                                                                    <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' />
                                                                </Form.Item> */}
                                                            </Col>
                                                            <Col span={24} style={{ marginBottom: 20 }}>
                                                                <Form.Item
                                                                    label="Tags"
                                                                    name="tags"
                                                                    id="tags"
                                                                >
                                                                    <Select
                                                                        getPopupContainer={getFieldPopupContainer}
                                                                        showSearch
                                                                        // open={false}
                                                                        className="lead-tags-input"
                                                                        mode="tags"
                                                                        style={{ width: "100%" }}
                                                                        optionFilterProp="label"
                                                                        filterOption={(input, option) =>
                                                                            option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        placeholder="Enter tags"
                                                                        tokenSeparators={[","]}
                                                                        options={tagOptions}
                                                                        loading={loadingList}
                                                                        virtual={false}
                                                                        onDropdownVisibleChange={(open) => {
                                                                            setTagsDropdownOpen(open);
                                                                            if (open && tagOptions.length === 0 && hasMoreTags) {
                                                                                fetchNextPage();
                                                                            }
                                                                        }}
                                                                        dropdownRender={(menu) => (
                                                                            <div
                                                                                ref={tagsPopupRef}
                                                                                onScroll={handlePopupScroll}
                                                                                style={{ maxHeight: 256, overflowY: "auto" }}
                                                                            >
                                                                                {menu}
                                                                            </div>
                                                                        )}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row >
                                                        <Heading as="h5">Account Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Account Name" name="accountName" id="accountName"
                                                                    rules={[{
                                                                        required: true,
                                                                        transform: (value) => value?.trim(), message: 'Please enter account name'
                                                                    }, {
                                                                        validator: (_, value) => {
                                                                            const error = nameOnChangeValidator(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}>
                                                                    <AutoComplete
                                                                        options={account.map(acc => ({
                                                                            value: acc.value, key: acc.key, data: acc.data, label: (
                                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                                    <span>{acc.value}</span>
                                                                                    <span>
                                                                                        ({acc.data.status})
                                                                                    </span>
                                                                                </div>
                                                                            ),
                                                                        }))}
                                                                        onSearch={handleAccountSearch}
                                                                        onSelect={(value, option) => {
                                                                            form.setFieldsValue({
                                                                                accountName: value,
                                                                                industry: option.data.industry,
                                                                                rating: option.data.rating,
                                                                                noofemployees: option.data.employee,
                                                                                annualrevenue: option.data.revenue,
                                                                                websiteName: option.data.website,
                                                                            });
                                                                            setContent2(option.data.description)
                                                                            setRelatedLead(option.data.leadId)
                                                                            setDataDisables(
                                                                                {
                                                                                    isDisable: option.data.status === "Qualified",
                                                                                    allow: option.data.status === "Qualified",
                                                                                    id: option.data.accountID,
                                                                                    profile: option.data.accountProfile
                                                                                }
                                                                            )
                                                                        }}
                                                                        notFoundContent={accountLoading ? <Spin size="small" /> : null}
                                                                        onChange={(inputValue) => {
                                                                            const match = account.find(acc => acc.value === inputValue);
                                                                            if (!match) {
                                                                                form.setFieldsValue({
                                                                                    industry: undefined,
                                                                                    rating: undefined,
                                                                                    noofemployees: undefined,
                                                                                    annualrevenue: undefined,
                                                                                    websiteName: undefined,
                                                                                });
                                                                                setContent2()
                                                                                setDataDisables({
                                                                                    isDisable: false,
                                                                                    allow: false,
                                                                                    id: null,
                                                                                    profile: null
                                                                                });
                                                                                setRelatedLead(null)
                                                                            }
                                                                        }}
                                                                        // options={account}
                                                                        // onSelect={onSelect}
                                                                        style={{ width: '100%' }}
                                                                        placeholder="Type or select an account"
                                                                        filterOption={false
                                                                            // (inputValue, option) =>
                                                                            // option.value.toLowerCase().includes(inputValue.toLowerCase())
                                                                        }
                                                                    >
                                                                        <Input />
                                                                    </AutoComplete>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Account Url" name="websiteName" id="websiteName" rules={
                                                                    [dataDisables?.isDisable ? { required: false } : {
                                                                        required: true,
                                                                        transform: (value) => value?.trim(), message: 'Please enter account url'
                                                                    },
                                                                    {
                                                                        validator: (_, value) => {
                                                                            const error = validateUrlField(value, 2000);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    },
                                                                    ]
                                                                }>
                                                                    <Input placeholder="Enter Account Url" disabled={dataDisables?.isDisable} />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>

                                                                <Form.Item label="Industry" name="industry"
                                                                    id="industry" rules={[dataDisables?.isDisable ? { required: false } : { required: true, message: 'Please enter industry' }]}>
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Industry" getPopupContainer={getFieldPopupContainer}
                                                                        showSearch disabled={dataDisables?.isDisable}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {industryData.map((option, i) => (
                                                                            <Option value={option.industryId} key={i}>
                                                                                {option.industryName}
                                                                            </Option>))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>

                                                                <Form.Item label="Rating" name="rating"
                                                                    id="rating" >
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Rating" disabled={dataDisables?.isDisable}
                                                                        showSearch allowClear onChange={(value) => form.setFieldsValue({ rating: value || null })}
                                                                        optionFilterProp="children" getPopupContainer={getFieldPopupContainer}
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {rating}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="No of Employees" name="noofemployees"
                                                                    id="noofemployees" >
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select No of Employees" disabled={dataDisables?.isDisable}
                                                                        showSearch allowClear onChange={(value) => form.setFieldsValue({ noofemployees: value || null })}
                                                                        optionFilterProp="children" getPopupContainer={getFieldPopupContainer}
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {noofemployee}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Annual Revenue (USD)" name="annualrevenue"
                                                                    id="annualrevenue" >
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Annual Revenue" disabled={dataDisables?.isDisable}
                                                                        showSearch allowClear onChange={(value) => form.setFieldsValue({ annualrevenue: value || null })}
                                                                        optionFilterProp="children" getPopupContainer={getFieldPopupContainer}
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {revenue}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={24} style={{ marginBottom: 20 }}>
                                                                <Form.Item label={
                                                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                                                        Account Description
                                                                        <button type="button" onClick={generateAiDescription} title="Generate description with AI"
                                                                            disabled={dataDisables?.isDisable || aiLoading}
                                                                            style={{
                                                                                display: 'inline-flex', alignItems: 'center', gap: 4, padding: "3px 8px", borderRadius: 20, border: "1px solid #6a5af9",
                                                                                background: "#6a5af926", color: "#6a5af9", fontFamily: "'Noto Sans',sans-serif", fontSize: 10.5, fontWeight: 700,
                                                                                cursor: (dataDisables?.isDisable || aiLoading) ? 'not-allowed' : 'pointer', opacity: aiLoading ? 0.7 : 1,
                                                                            }}>
                                                                            {aiLoading ? <Spin size="small" /> : <AiIcon width="11" height="11" />} AI
                                                                        </button>
                                                                    </span>
                                                                } >
                                                                    <TinyMCEEditor
                                                                        placeholder="Enter Account Description"
                                                                        content={content2}
                                                                        setContent={handleChange2}
                                                                        edit={!dataDisables?.isDisable}
                                                                        page="TextBoxs"
                                                                        height={150}
                                                                        selectedEntity="A"
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Heading as="h5">Address Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Country" name="country" id="country" rules={[{ message: 'Please select country', required: true }]} >
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch getPopupContainer={getFieldPopupContainer}
                                                                        placeholder="Select Country"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleCountryChange}
                                                                        value={country}
                                                                    >
                                                                        {allCountry?.map((option) => (
                                                                            <Option key={option.countryId} value={option.country}>
                                                                                {option.country}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="State" >
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch getPopupContainer={getFieldPopupContainer}
                                                                        placeholder="Select State"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleStateChange}
                                                                        value={state}
                                                                    >
                                                                        {allState?.map((option) => (
                                                                            <Option key={option.stateId} value={option.state}>
                                                                                {option.state}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="City" >
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch getPopupContainer={getFieldPopupContainer}
                                                                        placeholder="Select City"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleCityChange}
                                                                        value={city}
                                                                    >
                                                                        {allCity?.map((option) => (
                                                                            <Option key={option.cityId} value={option.city}>
                                                                                {option.city}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Street name and No" name="street" id="street" rules={[{
                                                                    validator: (_, value) => {
                                                                        const error = validateAddressLine(value, 100);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }]}>
                                                                    <Input placeholder="Enter Street name and no" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Zip Code" id="postcode" name="postcode" rules={[{
                                                                    validator: (_, value) => {
                                                                        const error = validateZipCode(value, 25);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }]}>
                                                                    <Input placeholder="Enter Zip Code" />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row >
                                                        <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                                        <Heading as="h5">Profile Picture</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <figure className="photoUpload align-center-v" >
                                                                    {image !== null && image !== undefined && image !== "" ?
                                                                        < img src={image} alt="" />
                                                                        :
                                                                        UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD" ?
                                                                            <span className='details_span_Tag LeadIcon'>
                                                                                {displayData?.first_name?.slice(0, 1).toUpperCase()}
                                                                            </span>
                                                                            :
                                                                            <span className='details_span_Tag LeadIcon'>
                                                                                L
                                                                            </span>}
                                                                    {edit && !imageUploading && <figcaption>
                                                                        {deleteOption ? (
                                                                            <div className='delete-div'>
                                                                                <span className='delete-span'>
                                                                                    <FeatherIcon icon="trash-2" className="icon-svg" size={16} onClick={handleDeleteImage} />
                                                                                </span>
                                                                            </div>) :
                                                                            (<div>
                                                                                <ImgCrop aspect={1} cropShape="round" rotationSlider modalTitle="Crop Image" beforeCrop={(file) => {
                                                                                    const allowedTypes = [
                                                                                        'image/png',
                                                                                        'image/jpeg',
                                                                                    ];

                                                                                    if (!allowedTypes.includes(file.type)) {
                                                                                        message.error('Only PNG, JPG and JPEG images are allowed');
                                                                                        return false;
                                                                                    }

                                                                                    return true;
                                                                                }}>
                                                                                    <Upload {...FileUpload}>
                                                                                        <Link className="btn-upload" to={combinedUrl}>
                                                                                            <FeatherIcon icon="camera" size={16} />
                                                                                        </Link>
                                                                                    </Upload>
                                                                                </ImgCrop>
                                                                            </div>)
                                                                        }
                                                                    </figcaption>
                                                                    }
                                                                </figure>
                                                            </Col>
                                                        </Row>
                                                        {(UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD" && drawerPage !== "CloneLead") && <>
                                                            <Heading as="h5">Other Information</Heading>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Created Date" >
                                                                        <span >{displayData?.created_at}</span>
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Created By" >
                                                                        <UploadUserTag record={{
                                                                            uploadedBy: `${displayData?.createdByFirstName} ${displayData?.createdByLastName}`,
                                                                            uploadedById: displayData?.created_by,
                                                                            uploadedProfile: displayData?.createdByProfilePic
                                                                        }} />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Modified Date" >
                                                                        <span >{displayData?.modified_at}</span>
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Modified By" >
                                                                        <UploadUserTag record={{
                                                                            uploadedBy: `${displayData?.modifiedByFirstName} ${displayData?.modifiedByLastName}`,
                                                                            uploadedById: displayData?.modified_by,
                                                                            uploadedProfile: displayData?.modifiedByProfilePic
                                                                        }} />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row >
                                                        </>}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </BasicFormWrapper>
                            </Form>
                        </div>
                    </AddUser>
                </Scrollbars>
                    :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer>
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Lead" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            <AddTaskPage UrlId={undefined} FromPage={createPageTask} setCratePage={setCreatePageTask} CallBackTrigger={setNaCTrigger} fromPageforTask="FromDetails" taskProp={taskProp} />
            <ComposeMail IsTrackUrl="No" mailOpen={mailOpen} close={closeMailComposr} entityName="Leads" entity="EntityPages" toId={[{ id: displayData?.leads_id, type: "Leads" }]} CallBackTrigger={setNaCTrigger} />
            {approveOpen && <Approvaldialog confirmPopup={approveOpen} setConfirmPopup={setApproveOpen} />}
            {campaignPopup && <AddtoSegment sharePopup={campaignPopup} setSharePopup={setCampaignPopup} sharingType="Lead" sharingIds={[leadId]} PageTypes="Single" />}
            {outreachPopup && <AddtoOutreachPopup sharePopup={outreachPopup} setSharePopup={setOutreachPopup} sharingType="Lead" sharingIds={leadId} PageTypes="Single" />}
            {sharePopup && <SharePopup sharePopup={sharePopup} setSharePopup={setSharePopup} sharingType="Lead" sharingIds={[leadId]} PageTypes="Single" />}
            {popup && <ConvertPopup popup={popup} setPopup={setPopup} GetAll={getDetailsDatas} popupType={popupType} values={values} action={action} assignOwner={assignOwner} successMessage={successMessage} setDoubleClick={setDelteClick} loadingRef={loadingRef} deleteClick={deleteClick} />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            {notePopup && <NotesPopup setNotePopup={setNotePopup} notePopup={notePopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} page={page} />}
            {callLogPopup && <CallLogPopup setCallLogPopup={setCallLogPopup} callLogPopup={callLogPopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} />}
            <MeetingLiPopup meetingOpen={meetingOpen} setMeetingOpen={setMeetingOpen} GetAll={getDetailsDatas} taskPage={taskPage} setNaCTrigger={setNaCTrigger} popupPageType="Create" meetingDate={formattedDate} meetingTime={formattedTime} Attendees={meetingAttendees} />
            <MergePage meetingOpen={mergeOpen} deletecheck={!hasRoleDeletePermission(permissions, 2004)} setMeetingOpen={setMergeOpen} GetAll={getDetailsDatas} pageIdentifier="Leads" setNaCTrigger={setNaCTrigger} PryData={displayData} />
        </>
    );
}
AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    ShortCut: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    CallBack: PropTypes.func.isRequired,
    MailData: PropTypes.object.isRequired,
    fromEmail: PropTypes.string.isRequired,
};

export default AddNew;